import { IProprietaryTimer } from '../../../FrontApplet/Management/helpers/ProprietaryTimerHelper';
import { ITimer, TimerType } from '../../../FrontApplet/Management/helpers/TimerHelper';
import { IScheduledRebootAction, IScheduledRebootRule, WeekdayType } from '../../../FrontApplet/Management/Power/IPower';
import { EmptyObject } from '../../EmptyObject';

export type PowerRequests =
	| PowerSystemRebootRequest
	| PowerSystemRebootResult
	| PowerAppRestartRequest
	| ManagementPowerGetTimersRequest
	| ManagementPowerSetTimerRequest
	| ManagementPowerUnsetTimerRequest
	| ManagementPowerGetProprietaryTimersRequest
	| ManagementPowerSetProprietaryTimerRequest
	| ManagementPowerUnsetProprietaryTimerRequest
	| ManagementPowerClearScheduledRebootsRequest
	| ManagementPowerGetScheduledRebootsRequest
	| ManagementPowerRemoveScheduledRebootRequest
	| ManagementPowerSetScheduledRebootRequest;

export const PowerSystemRebootRequest = 'sos.Monitoring.Management.Power.PowerSystemRebootRequest';
export interface PowerSystemRebootRequest {
	type: typeof PowerSystemRebootRequest;
}

export const PowerSystemRebootResult = 'sos.Monitoring.Management.Power.PowerSystemRebootResult';
export interface PowerSystemRebootResult {
	type: typeof PowerSystemRebootResult;
	result: EmptyObject;
}

export const PowerAppRestartRequest = 'sos.Monitoring.Management.Power.PowerAppRestartRequest';
export interface PowerAppRestartRequest {
	type: typeof PowerAppRestartRequest;
}

export const PowerAppRestartResult = 'sos.Monitoring.Management.Power.PowerAppRestartResult';
export interface PowerAppRestartResult {
	type: typeof PowerAppRestartResult;
	result: EmptyObject;
}

export const ManagementPowerGetTimersRequest = 'sos.Monitoring.Management.Power.ManagementPowerGetTimersRequest';
export interface ManagementPowerGetTimersRequest {
	type: typeof ManagementPowerGetTimersRequest;
}

export const ManagementPowerGetTimersResult = 'sos.Monitoring.Management.Power.ManagementPowerGetTimersResult';
export interface ManagementPowerGetTimersResult {
	type: typeof ManagementPowerGetTimersResult;
	timers: ITimer[];
}

export const ManagementPowerSetTimerRequest = 'sos.Monitoring.Management.Power.ManagementPowerSetTimerRequest';
export interface ManagementPowerSetTimerRequest {
	type: typeof ManagementPowerSetTimerRequest;
	timerType: keyof typeof TimerType;
	timeOn: string | null;
	timeOff: string | null;
	weekdays: string[];
	volume: number;
}

export const ManagementPowerSetTimerResult = 'sos.Monitoring.Management.Power.ManagementPowerSetTimerResult';
export interface ManagementPowerSetTimerResult {
	type: typeof ManagementPowerSetTimerResult;
	result: EmptyObject;
}

export const ManagementPowerUnsetTimerRequest = 'sos.Monitoring.Management.Power.ManagementPowerUnsetTimerRequest';
export interface ManagementPowerUnsetTimerRequest {
	type: typeof ManagementPowerUnsetTimerRequest;
	timerType: keyof typeof TimerType;
}

export const ManagementPowerUnsetTimerResult = 'sos.Monitoring.Management.Power.ManagementPowerUnsetTimerResult';
export interface ManagementPowerUnsetTimerResult {
	type: typeof ManagementPowerUnsetTimerResult;
	result: EmptyObject;
}

export const ManagementPowerGetProprietaryTimersRequest = 'sos.Monitoring.Management.Power.ManagementPowerGetProprietaryTimersRequest';
export interface ManagementPowerGetProprietaryTimersRequest {
	type: typeof ManagementPowerGetProprietaryTimersRequest;
}

export const ManagementPowerGetProprietaryTimersResult = 'sos.Monitoring.Management.Power.ManagementPowerGetProprietaryTimersResult';
export interface ManagementPowerGetProprietaryTimersResult {
	type: typeof ManagementPowerGetProprietaryTimersResult;
	result: IProprietaryTimer[];
}

export const ManagementPowerSetProprietaryTimerRequest = 'sos.Monitoring.Management.Power.ManagementPowerSetProprietaryTimerRequest';
export interface ManagementPowerSetProprietaryTimerRequest {
	type: typeof ManagementPowerSetProprietaryTimerRequest;
	timerType: keyof typeof TimerType;
	timeOn: string | null;
	timeOff: string | null;
	weekdays: string[];
	keepAppletRunning?: boolean;
}

export const ManagementPowerSetProprietaryTimerResult = 'sos.Monitoring.Management.Power.ManagementPowerSetProprietaryTimerResult';
export interface ManagementPowerSetProprietaryTimerResult {
	type: typeof ManagementPowerSetProprietaryTimerResult;
	result: EmptyObject;
}

export const ManagementPowerUnsetProprietaryTimerRequest = 'sos.Monitoring.Management.Power.ManagementPowerUnsetProprietaryTimerRequest';
export interface ManagementPowerUnsetProprietaryTimerRequest {
	type: typeof ManagementPowerUnsetProprietaryTimerRequest;
	timerType: keyof typeof TimerType;
}

export const ManagementPowerUnsetProprietaryTimerResult = 'sos.Monitoring.Management.Power.ManagementPowerUnsetProprietaryTimerResult';
export interface ManagementPowerUnsetProprietaryTimerResult {
	type: typeof ManagementPowerUnsetProprietaryTimerResult;
	result: EmptyObject;
}

export const ManagementPowerClearScheduledRebootsRequest = 'sos.Monitoring.Management.Power.ManagementPowerClearScheduledRebootsRequest';
export interface ManagementPowerClearScheduledRebootsRequest {
	type: typeof ManagementPowerClearScheduledRebootsRequest;
}

export const ManagementPowerClearScheduledRebootsResult = 'sos.Monitoring.Management.Power.ManagementPowerClearScheduledRebootsResult';
export interface ManagementPowerClearScheduledRebootsResult {
	type: typeof ManagementPowerClearScheduledRebootsResult;
	result: EmptyObject;
}

export const ManagementPowerGetScheduledRebootsRequest = 'sos.Monitoring.Management.Power.ManagementPowerGetScheduledRebootsRequest';
export interface ManagementPowerGetScheduledRebootsRequest {
	type: typeof ManagementPowerGetScheduledRebootsRequest;
}

export const ManagementPowerGetScheduledRebootsResult = 'sos.Monitoring.Management.Power.ManagementPowerGetScheduledRebootsResult';
export interface ManagementPowerGetScheduledRebootsResult {
	type: typeof ManagementPowerGetScheduledRebootsResult;
	result: IScheduledRebootAction<IScheduledRebootRule>[];
}

export const ManagementPowerRemoveScheduledRebootRequest = 'sos.Monitoring.Management.Power.ManagementPowerRemoveScheduledRebootRequest';
export interface ManagementPowerRemoveScheduledRebootRequest {
	type: typeof ManagementPowerRemoveScheduledRebootRequest;
	id: string;
}

export const ManagementPowerRemoveScheduledRebootResult = 'sos.Monitoring.Management.Power.ManagementPowerRemoveScheduledRebootResult';
export interface ManagementPowerRemoveScheduledRebootResult {
	type: typeof ManagementPowerRemoveScheduledRebootResult;
	result: EmptyObject;
}

export const ManagementPowerSetScheduledRebootRequest = 'sos.Monitoring.Management.Power.ManagementPowerSetScheduledRebootRequest';
export interface ManagementPowerSetScheduledRebootRequest {
	type: typeof ManagementPowerSetScheduledRebootRequest;
	weekdays: WeekdayType[];
	time: string;
}

export const ManagementPowerSetScheduledRebootResult = 'sos.Monitoring.Management.Power.ManagementPowerSetScheduledRebootResult';
export interface ManagementPowerSetScheduledRebootResult {
	type: typeof ManagementPowerSetScheduledRebootResult;
	result: EmptyObject;
}
